(function () {
  var root = document.querySelector("[data-secret-drop]");
  var stage = document.querySelector("[data-secret-stage]");
  var cloth = document.querySelector("[data-secret-cloth]");
  var hero = document.querySelector(".secret-drop__hero");
  if (!root) return;

  var started = Date.now();
  var revealed = false;
  function reveal() {
    if (revealed) return;
    revealed = true;
    var wait = Math.max(0, 500 - (Date.now() - started));
    setTimeout(function () {
      root.classList.add("is-ready");
    }, wait);
  }
  if (document.readyState === "complete") reveal();
  else window.addEventListener("load", reveal);
  setTimeout(reveal, 2200);

  if (!stage || !cloth) return;

  var maxLift = 0.78;
  var holdLift = 0.58;
  var lift = 0;
  var dragging = false;
  var startY = 0;
  var startLift = 0;
  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function apply(next) {
    lift = Math.max(0, Math.min(maxLift, next));
    cloth.style.transform = "translate3d(0," + (-lift * 100) + "%,0)";
    stage.classList.toggle("is-peeking", lift > 0.08);
  }

  function settle() {
    dragging = false;
    cloth.style.transition = reduced ? "none" : "transform 560ms cubic-bezier(0.22, 1, 0.36, 1)";
    apply(0);
  }

  cloth.addEventListener("pointerdown", function (event) {
    dragging = true;
    startY = event.clientY;
    startLift = lift;
    cloth.setPointerCapture(event.pointerId);
    cloth.style.transition = reduced ? "none" : "transform 380ms cubic-bezier(0.22, 1, 0.36, 1)";
    apply(Math.max(lift, holdLift));
  });

  cloth.addEventListener("pointermove", function (event) {
    if (!dragging) return;
    var delta = (startY - event.clientY) / Math.max(stage.offsetHeight, 1);
    if (Math.abs(delta) > 0.02) {
      cloth.style.transition = "none";
      apply(startLift + holdLift + delta);
    }
  });

  cloth.addEventListener("pointerup", settle);
  cloth.addEventListener("pointercancel", settle);
  cloth.addEventListener("lostpointercapture", function () {
    if (dragging) settle();
  });

  cloth.addEventListener("keydown", function (event) {
    if (event.code !== "Space" && event.code !== "Enter") return;
    event.preventDefault();
    cloth.style.transition = reduced ? "none" : "transform 380ms cubic-bezier(0.22, 1, 0.36, 1)";
    apply(holdLift);
  });

  cloth.addEventListener("keyup", function (event) {
    if (event.code === "Space" || event.code === "Enter") settle();
  });

  if (hero && !reduced) {
    hero.addEventListener("pointermove", function (event) {
      var box = hero.getBoundingClientRect();
      hero.style.setProperty("--mx", event.clientX - box.left + "px");
      hero.style.setProperty("--my", event.clientY - box.top + "px");
    });
  }

  stage.addEventListener("contextmenu", function (event) {
    event.preventDefault();
  });
  stage.addEventListener("dragstart", function (event) {
    event.preventDefault();
  });
})();
